import 'slick-carousel';

function componentHomepageHero($) {
	function initComponentSlider() {
		$('.component_homepage-hero__slider').on(
			'init reInit afterChange',
			function (event, slick, currentSlide, nextSlide) {
				const i = (currentSlide ? currentSlide : 0) + 1;
				$('.slider-count .current').text(i);
				$('.slider-count .total').text(slick.slideCount);
			}
		);

		$('.component_homepage-hero__slider')
			.not('.slick-initialized')
			.slick({
				infinite: false,
				slidesToShow: 1,
				slidesToScroll: 1,
				prevArrow: document.querySelector(
					'.component_homepage-hero__slider-arrows .prev'
				),
				nextArrow: document.querySelector(
					'.component_homepage-hero__slider-arrows .next'
				),
			});
	}

	$(document).ready(function () {
		initComponentSlider();
		$(window).on('resize', function () {
			initComponentSlider();
		});
	});
}

export default componentHomepageHero;
